<template>
    <div class="container">

        <div class="box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <p class="heading has-text-weight-bold is-size-5">Ipad Users</p>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <button class="create-button button" @click="openCloseIpadUserModal">
                                  <span class="icon is-small">
                                        <i class="fas fa-plus-circle"></i>
                                  </span>
                                  <span>Create</span>
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns"  style="justify-content: right;">
                <div class="column has-text-right">
                    <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                        <div class="tooltiptext">
                            <ul style="list-style: disc outside">
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can see the users using the iPad.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can update the user</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can add a new user.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">CAI or CXI captain can be added.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="user-table">
            <table class="table is-striped is-fullwidth is-bordered animate__animated animate__slideInUp animate__faster">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>TLC</th>
                        <th>FullName</th>
                        <th>UserName</th>
                        <th>IsActive</th>
                        <th>Created</th>
                        <th>Updated</th>
                        <th>Act</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in this.userList" :key="user.id">
                        <td>{{user.id}}</td>
                        <td>{{user.tlc}}</td>
                        <td>{{user.fullName}}</td>
                        <td>{{user.userName}}</td>
                        <td>{{user.isActive}}</td>
                        <td>{{user.createdAt|longFormatDateFromString}}</td>
                        <td>{{user.updatedAt|longFormatDateFromString}}</td>
                        <td>
                            <button title="Edit" class="button is-small is-light is-info" @click="editUser(user.id)"><font-awesome-icon icon="edit"/>
                                Edit
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="modal " v-bind:class="{'is-active':isActiveModal}">
            <div class="modal-background" @click="openCloseIpadUserModal"></div>
            <div class="modal-card animate__animated animate__zoomIn animate__faster" style="width:40%; height: 40%;">
                <header class="modal-card-head">
                    <p class="modal-card-title">Ipad User</p>
                    <button class="delete is-large" @click="openCloseIpadUserModal" aria-label="close">Close</button>
                </header>
                <section class="modal-card-body" style="width: 100%; height: 100%">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">TLC</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="user.id != null" class="input " type="text" v-model="user.tlc">
                                    <input v-else class="input" type="text" v-model="userForm.tlc">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Full Name</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="user.id != null" class="input " type="text"
                                           v-model="user.fullName">
                                    <input v-else class="input " type="text" v-model="userForm.fullName">
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">User Name</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="user.id != null" class="input " type="text" v-model="user.userName">
                                    <input style="width: 50%" v-else class="input" type="text" v-model="userForm.userName">

                                    <select v-if="user.id == null" style="width: 49%; ;border:2px solid #a0a0a0;border-radius: 4px;margin-left: 4px;height: 41px;" class="select is-medium selectbox" v-model ="selectedMail">
                                        <option v-for="(mailItem,index) in maillist" :key="index" :value="mailItem">
                                            {{mailItem}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Password</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input v-if="user.id != null" class="input " type="password" v-model="user.password">
                                    <input style="width: 100%" v-else class="input" type="password" v-model="userForm.password">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Is Active</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">

                                    <label class="radio" v-if="user.id != null">
                                        <input type="radio" name="IsActive" v-model="user.isActive" v-bind:value="true">
                                        True
                                    </label>
                                    <label class="radio" v-else>
                                        <input type="radio" name="IsActive" v-model="userForm.isActive" v-bind:value="true">
                                        True
                                    </label>

                                    <label class="radio" v-if="user.id != null">
                                        <input type="radio" name="IsActive" v-model="user.isActive" v-bind:value="false">
                                        False
                                    </label>
                                    <label class="radio" v-else>
                                        <input type="radio" name="IsActive" v-model="userForm.isActive" v-bind:value="false">
                                        False
                                    </label>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <footer class="modal-card-foot">
                    <div v-if="user.id != null" class="field">
                        <div class="control">
                            <button class="create-button button" @click="TryUpdateUser(user)">
                                  <span class="icon is-small">
                                     <i class="fas fa-edit"></i>
                                  </span>
                                <span>Update</span>
                            </button>
                        </div>
                    </div>
                    <div v-else class="field">
                        <div class="control">
                            <div class="control">
                                <button class="create-button button" @click="TryAddUser(userForm)">
                                  <span class="icon is-small">
                                     <i class="fas fa-save"></i>
                                  </span>
                                    <span>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </footer>

            </div>
        </div>
    </div>
</template>

<script>


    import {mapState, mapActions} from "vuex";
    import {loadingMixin} from "../../../utils/mixins";
    import LoadingButton from "../../../components/ui/LoadingButton";
    export default {
        name: "IpadUserList",
        mixins: [loadingMixin],
        components: {
            // eslint-disable-next-line vue/no-unused-components
            LoadingButton,
        },

        data()
        {

            return {
                isActiveUserModal: false,
                userForm:{
                    id: 0,
                    tlc:'',
                    fullName:'',
                    userName:'',
                    isActive:false,
                },
                // premail : "@corendon-airlines.com",
                maillist : ["@corendon-airlines.com","@corendonairlines.com.mt"],
                selectedMail : "@corendon-airlines.com"
            }

        },

        created() {
            this.TrygetUsers();
        },

        methods: {

            ...mapActions("ipadusers",["getipadUsers","getipadUser","UpdateipadUser","AddipadUser","openCloseIpadUserModal"]),

            editUser(id)
            {
                this.openCloseIpadUserModal();
                this.getipadUser(id);
            },

            async TrygetUsers() {
                this.showLoading();
                try {
                    await this.getipadUsers();
                } catch (e) {
                    this.$notify({title: "Error", text:"Error on TrygetUsers function e: " + e.message, type: "error"});
                } finally {
                    this.hideLoading();
                }
            },

            async TryUpdateUser(value) {
                try {
                    var message ="";
                    message = await this.UpdateipadUser(value);

                    if(message.stat != 1)
                    {
                        this.$notify({title: "Error", type: "error", text: "stat is "+message.stat + " " +message.message });
                        return ;
                    }

                    console.log(message);

                    this.openCloseIpadUserModal();
                    this.$notify({title: "Success", type: "success", text: "Succesfully Saved"})
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text:"Error on TryUpdateUser " + e.message + " " + message})
                }
            },

            async TryAddUser(value) {
                try {
                    value.userName= value.userName + this.selectedMail;
                    var message ="";
                    message = await this.AddipadUser(value);

                    if(message.stat != 1)
                    {
                        this.$notify({title: "Error", type: "error", text: "stat is "+message.stat + " " +message.message });
                        return ;
                    }

                    console.log(message);

                    this.openCloseIpadUserModal();
                    this.$notify({title: "Success", type: "success", text: "Succesfully Saved "})
                    this.addForm = {};
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text:"Error on TryAddUser e: " + e.message + " " + message})
                }
            },

        },

        computed: {
            ...mapState("ipadusers",["userList","user","isActiveModal"]),
        }
    }

</script>

<style scoped>

    .selectbox
    {
        border-radius: 3px;


    }

    .user-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .create-button {
        background-color: #6a85a7;
        color: white;
        font-size: 10px;
        font-size: 1.1rem;
        min-height: auto;
    }

    .user-table td {
        border: 0px;
    }

    .user-table {
        overflow-y: scroll;
        height: 790px;
    }

    .user-table th {
        top: -12px;
        position: sticky;
        background-color: white;
        z-index: 2;
    }

    .user-menu {
        background-color: #fff;
        /*border-radius: 6px;*/
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
        color: #4a4a4a;
        display: block;
        padding: 1.25rem;
        margin-bottom: 5px;
        margin-top: 5px;
    }

    .role-selected {
        border: 0;
        cursor: pointer;
        font-size: 1em;
        font-family: Arial;
        position: relative;
    }

    .role-selected option {
        background-color: #6a85a7;
        color: white;
        font-family: sans-serif;
        font-style: unset;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 99;
        position: absolute;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

</style>
